import React from 'react';
import PropTypes from 'prop-types';

import SubmitButton from '../SubmitButton';
import Icon from '../../../../../assets/images/pro/pay_with_apple.svg';

import * as styles from '../styles/styles.module.scss';

const PayWithApplebutton = ({ text, handler }) => {
  const content = (
    <span className={styles.contents}>
      {text}
      <img className={styles.applePayIcon} src={Icon} />
    </span>
  );

  return <SubmitButton text={content} handler={handler} variant="appleCheckout" />;
};

PayWithApplebutton.defaultProps = {
  text: 'Checkout with Apple',
  handler: () => {}
};

PayWithApplebutton.propTypes = {
  text: PropTypes.string,
  handler: PropTypes.func
};

export default PayWithApplebutton;
